import { Link } from "react-router-dom";
import type { LandingContent, Locale } from "../content/types";
import { getPath } from "../lib/paths";

type SiteFooterProps = {
  content: LandingContent["footer"];
  nav: LandingContent["nav"];
  locale: Locale;
};

export function SiteFooter({ content, nav, locale }: SiteFooterProps) {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <strong>Moodshot</strong>
        <p>{content.tagline}</p>
        <nav aria-label={content.footerNavLabel}>
          <Link to={getPath("privacy", locale)}>{nav.privacy}</Link>
          <Link to={getPath("support", locale)}>{nav.support}</Link>
          <Link to={getPath("terms", locale)}>{nav.terms}</Link>
          <a href={content.contactHref}>{content.contact}</a>
        </nav>
        <small>
          {content.copyright}{" "}
          <a href={content.axqoraHref} className="footer-compliance-link">
            {content.axqora}
          </a>{" "}
          ·{" "}
          <a href={content.icpHref} className="footer-compliance-link" rel="noopener noreferrer" target="_blank">
            {content.icp}
          </a>
        </small>
      </div>
    </footer>
  );
}
